import React from "react";
import MapPage from "../pages/MapPage/MapPage"; // Adjust the path if needed

const MapLayout = ({ children }) => {
  return (
    <div style={{ position: "relative", width: "100vw", height: "100vh" }}>
      <MapPage /> {/* This is your live map */}
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
        {children} {/* This is where CastleDetailsPart2 will appear on top */}
      </div>
    </div>
  );
};

export default MapLayout;
